import React from 'react'
import { useTranslation } from 'react-i18next'

import { PanelContainer } from '../../../../components/Panel'
import { useConfigContext } from '../../../ui-config'
import { AdditionalDocumentsTable } from './tables'

type Props = {
  despatchAdviceId: string
}

export const Attachment: React.FC<Props> = ({ despatchAdviceId }) => {
  const { t } = useTranslation()
  const { uiConfig: config } = useConfigContext()

  return (
    <PanelContainer
      header={t('deliveryForecastDespatchAdvice.attachment.title')}
      id="delivery-forecast-despatch-advice-attachments"
      visible={config.deliveryForecastDespatchAdvice.attachment.enabled}
    >
      <AdditionalDocumentsTable despatchAdviceId={despatchAdviceId} />
    </PanelContainer>
  )
}
